/*
 * Desktop - Side Cart - Compact Horizontal Trustpilot Widget  --  variant: Slim Horizontal Badge
 * Moonshot experiment id: du65wzeH7MNBxNRHsB2BEo   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-07-13
 * Audience: DESKTOP   Target: side_cart   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_sc_d_trustpilot_widget
 */
MGExp.run('sc_d_trustpilot_widget', { name: "Desktop - Side Cart - Compact Horizontal Trustpilot Widget / Slim Horizontal Badge", platform: 'desktop', target: 'side_cart' }, function () {
  !(function () {
    let t = [],
      a = [];
    !(async function (i, e, n, s, o) {
      let p = {
        multi_target_selectors: t,
        exclude_from_timeout: a,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, e, n, s, o, p);
    })(
      [
        ".bag-container .trustpilot-widget:not(.announcement-bar)",
        ".bag-container .mc-icons",
      ],
      ".msai-tp-custom",
      function (t, a) {
        const [i, e] = a;
        i.classList.remove("trustpilot-widget");
        const n = i.getElementsByTagName("iframe")[0];
        (n && n.remove(),
          [
            "data-template-id",
            "data-businessunit-id",
            "data-token",
            "data-style-height",
            "data-style-width",
            "data-locale",
            "data-theme",
            "data-stars",
            "data-review-languages",
          ].forEach(function (t) {
            i.removeAttribute(t);
          }));
        const s =
            "M14 4.5 16.23 10.93 23.03 11.07 17.61 15.17 19.58 21.69 14 17.8 8.42 21.69 10.39 15.17 4.97 11.07 11.77 10.93Z",
          o =
            '<svg class="msai-multi-tp-star" width="23" height="23" viewBox="0 0 28 28" aria-hidden="true"><rect width="28" height="28" fill="#00B67A"></rect><path d="' +
            s +
            '" fill="#ffffff"></path></svg>',
          p =
            '<svg width="16" height="16" viewBox="0 0 28 28" aria-hidden="true"><path d="' +
            s +
            '" fill="#00B67A"></path></svg>';
        ((i.innerHTML =
          '<div class="msai-tp-inner"><span class="msai-tp-label">Excellent</span><span class="msai-tp-stars">' +
          o.repeat(5) +
          '</span><a class="msai-tp-reviews" href="https://www.trustpilot.com/review/mygemma.com" target="_blank" rel="noopener"><span class="msai-tp-count-group"><span class="msai-tp-count">3k+</span> reviews on</span><span class="msai-tp-logo">' +
          p +
          "<span>Trustpilot</span></span></a></div>"),
          i.nextElementSibling !== e && e.parentElement.insertBefore(i, e),
          i.classList.add("msai-tp-custom"));
      },
      ".bag-container .trustpilot-widget.announcement-bar,.bag-container .trustpilot-widget:not(.msai-tp-custom){display:none !important}.bag-container .msai-tp-custom{height:auto !important;min-height:0 !important;padding:0 !important;margin:16px 0 16px !important;background-color:transparent !important;display:block !important;box-sizing:border-box !important}.bag-container .msai-tp-custom .msai-tp-inner{display:flex;align-items:center;justify-content:center;flex-wrap:nowrap;white-space:nowrap;gap:9px;font-family:Helvetica,Arial,sans-serif;line-height:1}.bag-container .msai-tp-custom .msai-tp-label{font-weight:700;font-size:15px;color:#191919;letter-spacing:.2px}.bag-container .msai-tp-custom .msai-tp-stars{display:inline-flex;gap:2px}.bag-container .msai-tp-custom .msai-multi-tp-star{display:block}.bag-container .msai-tp-custom .msai-tp-reviews{display:inline-flex;align-items:center;gap:5px;text-decoration:none;color:#191919;font-size:14px}.bag-container .msai-tp-custom .msai-tp-count-group{text-decoration:underline}.bag-container .msai-tp-custom .msai-tp-count{font-weight:700}.bag-container .msai-tp-custom .msai-tp-logo{display:inline-flex;align-items:center;gap:3px;font-weight:700}",
    );
  })();
});
